<template>
  <router-link
    v-if="type === 'router-link'"
    class="back-link"
    data-sb-regression="sb-back-link"
    :to="to"
  >
    <i
      aria-hidden="true"
      class="sb-icon-chevron-left"
    />
    <!--
      @slot text, components, or HtmlElements as children of the component
     -->
    <slot />
  </router-link>
  <SbButton
    v-else
    :href="href"
    :type="href ? 'a' : 'button'"
    variation="link"
    class="back-link"
    data-sb-regression="sb-back-link"
    v-bind="$attrs"
    v-on="$attrs"
  >
    <i
      aria-hidden="true"
      class="sb-icon-chevron-left"
    />
    <!--
      @slot text, components, or HtmlElements as children of the component
     -->
    <slot />
  </SbButton>
</template>
<script>

import SbButton from '@src/components/Button/SbButton.vue';

/**
 * Link component to go back to previous page.
 */
export default {
  name: 'SbBackLink',
  components: {
    SbButton,
  },
  props: {
    /**
     * Use this prop when navigating within the SPA using Vue Router.
     * Accepts router location objects like { name: 'routeName' } or { path: '/some/path' }.
     * @example { name: 'UserList' } or { path: '/users', query: { page: 1 } }
     */
    to: {
      type: Object,
      required: false,
      default: null,
    },
    /**
     * URL for external links or absolute paths. The component will render as an anchor tag when href is provided.
     * @example 'https://example.com' or '/static/page.html'
     */
    href: {
      type: String,
      required: false,
      default: null,
    },
    /**
     * Determines the rendering type and navigation behavior of the back link.
     * - 'router-link': Uses Vue Router for SPA navigation (requires 'to' prop)
     * - 'button': Renders as button/anchor for external links or custom actions (uses 'href' prop or click events)
     */
    type: {
      type: String,
      default: 'router-link',
      validator: (value) => value.match(/(router-link|button)/),
    },
  },
};
</script>

<style lang='scss'>
@import '@src/components/BackLink/style/sb-back-link.scss';
</style>
